import api from "./index";

/**
 * Get nearest weather stations
 * @param {number} lat - Latitude
 * @param {number} lon - Longitude
 * @param {number} limit - Number of stations (default 25)
 * @returns {Array} list of weather stations
 */
export async function getNearestWeatherStations(lat, lon, limit = 25) {
    const res = await api.post("/ws/nearest", {
        lat,
        lon,
        limit
    });
    return res.data;
}
